// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__JpZ-d","error":"Textarea_error__3ByZp","readonly":"Textarea_readonly__2apCE","disabled":"Textarea_disabled__3BYfJ"};